var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mr-auto mt-2 mt-lg-0" }, [
    !_vm.omegaUpLockDown && (!_vm.inContest || _vm.isAdmin)
      ? _c("ul", { staticClass: "navbar-nav align-items-start px-3" }, [
          _vm.isLoggedIn
            ? _c(
                "li",
                {
                  staticClass: "nav-item dropdown nav-contests nav-item-align",
                  class: { active: _vm.navbarSection === "contests" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2 dropdown-toggle",
                      attrs: {
                        href: "#",
                        role: "button",
                        "data-nav-contests": "",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.T.wordsContests) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-menu fullwidth-mobile-fit-lg navbar-item-dropdown",
                    },
                    [
                      _vm._t("contests-items", function () {
                        return _vm._l(
                          _vm.contestsEntries,
                          function (entry, index) {
                            return _c(
                              "omegaup-navbar-item",
                              _vm._b(
                                {
                                  key: `contests-item-${index}`,
                                  attrs: {
                                    title: entry.title,
                                    description: entry.description,
                                    icon: entry.icon,
                                    href: entry.href,
                                  },
                                },
                                "omegaup-navbar-item",
                                entry.dataAttr ? { [entry.dataAttr]: "" } : {},
                                false
                              )
                            )
                          }
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _c(
                "li",
                { class: { active: _vm.navbarSection === "contests" } },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2",
                      attrs: { href: "/arena/", "data-nav-contests-arena": "" },
                    },
                    [_vm._v(_vm._s(_vm.T.wordsContests))]
                  ),
                ]
              ),
          _vm.isLoggedIn
            ? _c(
                "li",
                {
                  staticClass: "nav-item dropdown nav-courses nav-item-align",
                  class: { active: _vm.navbarSection === "courses" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2 dropdown-toggle",
                      attrs: {
                        href: "#",
                        role: "button",
                        "data-nav-courses": "",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.T.navCourses) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-menu fullwidth-mobile-fit-lg navbar-item-dropdown",
                    },
                    [
                      _vm._t("courses-items", function () {
                        return _vm._l(
                          _vm.coursesEntries,
                          function (entry, index) {
                            return _c(
                              "omegaup-navbar-item",
                              _vm._b(
                                {
                                  key: `courses-item-${index}`,
                                  attrs: {
                                    title: entry.title,
                                    description: entry.description,
                                    icon: entry.icon,
                                    href: entry.href,
                                  },
                                },
                                "omegaup-navbar-item",
                                entry.dataAttr ? { [entry.dataAttr]: "" } : {},
                                false
                              )
                            )
                          }
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _c(
                "li",
                {
                  class: { active: _vm.navbarSection === "course" },
                  attrs: { "data-nav-course": "" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2",
                      attrs: { href: "/course/home/" },
                    },
                    [_vm._v(_vm._s(_vm.T.navCourses))]
                  ),
                ]
              ),
          _c(
            "li",
            {
              staticClass: "nav-item dropdown nav-problems nav-item-align",
              class: { active: _vm.navbarSection === "problems" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link px-2 dropdown-toggle",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "dropdown",
                    "data-nav-problems": "",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.T.wordsProblems) + " ")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu fullwidth-mobile-fit-lg navbar-item-dropdown",
                },
                [
                  _vm._t("problems-items", function () {
                    return [
                      _vm._l(_vm.problemsEntries, function (entry, index) {
                        return [
                          entry.divider
                            ? _c("hr", {
                                key: `problems-divider-${index}`,
                                staticClass: "menu-divider",
                              })
                            : _c(
                                "omegaup-navbar-item",
                                _vm._b(
                                  {
                                    key: `problems-item-${index}`,
                                    attrs: {
                                      title: entry.title,
                                      description: entry.description,
                                      icon: entry.icon,
                                      href: entry.href,
                                    },
                                  },
                                  "omegaup-navbar-item",
                                  entry.dataAttr
                                    ? { [entry.dataAttr]: "" }
                                    : {},
                                  false
                                )
                              ),
                        ]
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
          _c(
            "li",
            {
              staticClass: "nav-item dropdown nav-rank nav-item-align",
              class: { active: _vm.navbarSection === "rank" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link px-2 dropdown-toggle",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.T.navRanking) + " ")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu fullwidth-mobile-fit-lg navbar-item-dropdown",
                },
                _vm._l(_vm.rankingEntries, function (entry, index) {
                  return _c(
                    "omegaup-navbar-item",
                    _vm._b(
                      {
                        key: `ranking-item-${index}`,
                        attrs: {
                          title: entry.title,
                          description: entry.description,
                          icon: entry.icon,
                          href: entry.href,
                        },
                      },
                      "omegaup-navbar-item",
                      entry.dataAttr ? { [entry.dataAttr]: "" } : {},
                      false
                    )
                  )
                }),
                1
              ),
            ]
          ),
          _c("li", { staticClass: "nav-item dropdown nav-item-align" }, [
            _c(
              "a",
              {
                staticClass: "nav-link px-2 dropdown-toggle",
                attrs: {
                  href: "#",
                  role: "button",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                },
              },
              [_vm._v(" " + _vm._s(_vm.T.navHelp) + " ")]
            ),
            _c(
              "div",
              {
                staticClass:
                  "dropdown-menu fullwidth-mobile-fit-lg navbar-item-dropdown",
              },
              [
                _vm._l(_vm.helpEntries, function (entry, index) {
                  return [
                    entry.divider
                      ? _c("hr", {
                          key: `help-divider-${index}`,
                          staticClass: "menu-divider",
                        })
                      : _c("omegaup-navbar-item", {
                          key: `help-item-${index}`,
                          attrs: {
                            title: entry.title,
                            description: entry.description,
                            icon: entry.icon,
                            href: entry.href,
                            target: entry.target,
                            rel: entry.rel,
                          },
                        }),
                  ]
                }),
              ],
              2
            ),
          ]),
        ])
      : _c("ul", { staticClass: "navbar-nav mr-auto" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }